import { GET_NULL_WSPOSITIONS, GET_NULL_WSPOSITIONS_SUCCESS, GET_NULL_WSPOSITIONS_ERROR} from './actionTypes';

export const getNullWsPositions = (user) => {
    return {
        type: GET_NULL_WSPOSITIONS,
        payload: { user }
    }
}

export const getNullWsPositionsSuccess = (ws_positions, message) => {
    return {
        type: GET_NULL_WSPOSITIONS_SUCCESS,
        payload: {ws_positions, message}
    }
}

export const getNullWsPositionsError = (message) => {
    return {
        type: GET_NULL_WSPOSITIONS_ERROR,
        payload: message
    }
}
